import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

export const alertsAdapter = createEntityAdapter({
  selectId: (alert) => alert.id,
  sortComparer: (a, b) => (a.title || '').localeCompare(b.title || ''),
});


const initialState = {
  ...alertsAdapter.getInitialState(),
}

const alertSlice = createSlice({
  name: 'alertStore',
  initialState,
  reducers: {
    addAlert: (state, action) => {
      const payload = typeof action.payload === 'string' ? {
        text: action.payload,
      } : action.payload;
      const text = payload.text || '';
      const severity = payload.severity || 'info';

      alertsAdapter.addOne(state, {
        id: +new Date(),
        text,
        severity,
      })
    },
    removeAlert: (state, action) => {
      const id = action.payload;

      // remove instant click away
      if ((+ new Date()) - id > 500) {
        alertsAdapter.removeOne(state, id);
      }
    }
  },
});

export const { addAlert, removeAlert } = alertSlice.actions;

export default alertSlice;